import { useEffect, useState } from 'react';
import { IconDown, IconUp } from '@ui/src';
import { AccountFlowCurrencyTypes } from './types';
import AccountFlow from './account-flow';

import cn from './styles.module.css';

const AccountFlowCurrency = ({
  accountsFlows,
  setAccountsFlowsValues,
  accountsFlowsValues,
  currencyId,
  currenciesList,
  status,
}: AccountFlowCurrencyTypes) => {
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (
      accountsFlowsValues?.length &&
      accountsFlowsValues?.find((item) => item.id?.includes('accounts-flow'))
    ) {
      setExpanded(true);
    }
  }, [accountsFlowsValues]);

  return (
    <div className={cn.accountFlow}>
      <button
        type="button"
        className={`${cn.accoutFlowButton} ${!expanded ? cn.collapsed : ''}`}
        onClick={() => setExpanded(!expanded)}
      >
        {expanded ? (
          <IconUp width={14} height={14} />
        ) : (
          <IconDown width={14} height={14} />
        )}
        {currenciesList?.find((item) => item.id === currencyId)?.name}
      </button>
      {expanded && (
        <div className={cn.accountFlowContent}>
          <div className={cn.accountFlowContentItem}>
            <div className={cn.accountFlowContentItemTitle}>
              Outgoing transactions
            </div>
            {accountsFlowsValues
              ?.filter((item) => item.transactionType === 'OUTGOING')
              ?.map((item) => (
                <AccountFlow
                  key={item.id}
                  accountsFlows={accountsFlows}
                  accountFlow={item}
                  setAccountsFlowsValues={setAccountsFlowsValues}
                  currenciesList={currenciesList}
                  status={status}
                />
              ))}
          </div>
          <div className={cn.accountFlowContentSeparator} />
          <div className={cn.accountFlowContentItem}>
            <div className={cn.accountFlowContentItemTitle}>
              Incoming transactions
            </div>
            {accountsFlowsValues
              ?.filter((item) => item.transactionType === 'INCOMING')
              ?.map((item) => (
                <AccountFlow
                  key={item.id}
                  accountsFlows={accountsFlows}
                  accountFlow={item}
                  setAccountsFlowsValues={setAccountsFlowsValues}
                  currenciesList={currenciesList}
                  status={status}
                />
              ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AccountFlowCurrency;
